import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TechnicalDashboardComponent } from './technicaldashboard.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [TechnicalDashboardComponent],
  exports: [
    TechnicalDashboardComponent
  ],
  providers: [
  ]
})
export class TechnicalDashboardModule { }
